import * as actionTypes from './actionTypes';

export const set3DNumberToUpdate=(number)=>({
    type:actionTypes.SET_3D_NUMBER_TO_UPDATE,
    payload:number
})